import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaypalService {

  private URL: string = environment.rootUrl;

  constructor(
    private http: HttpClient
  ) { }

  public paymentPaypalCard() {
    return this.http.post(`${this.URL}/cart/paypal/card`, {}).toPromise();
  }

  public paymentPaypalAccount() {
    return this.http.post(`${this.URL}/cart/paypal/account`, {}).toPromise();
  }

  /* NEW PAYPAL SERVICES */
  public async getDataClientToken(): Promise<any> {
    return this.http.get(`${this.URL}/cart/paypal/client-token`).toPromise();
  }

  public async createBillingAgreementToken(uuid: string): Promise<any> {
    return this.http.post(`${this.URL}/cart/paypal/billing-agreement/token?uuid=${uuid}`, {}).toPromise();
  }

  public async getPaymentMethods(token?: string): Promise<any> {
    let httpHeaders: any;
    if (token) {
      httpHeaders = new HttpHeaders({
        Authorization: token
      });
      return this.http.get(`${this.URL}/payment-methods`, { headers: httpHeaders }).toPromise();
    } else {
      return this.http.get(`${this.URL}/payment-methods`).toPromise();
    }
  }

  public async mergeCardToCart(data: any, token?: string): Promise<any> {
    let httpHeaders: any;
    if (token) {
      httpHeaders = new HttpHeaders({
        Authorization: token
      });
      return this.http.patch(`${this.URL}/cart/paypal/card`, data, { headers: httpHeaders }).toPromise();
    } else {
      return this.http.patch(`${this.URL}/cart/paypal/card`, data).toPromise();
    }
  }

  public async mergeAccountToCart(data: any): Promise<any> {
    return this.http.patch(`${this.URL}/cart/paypal/account`, data).toPromise();
  }

  public async createOrderPaypal(uuid: string, token?: string): Promise<any> {
    let httpHeaders: any;
    if (token) {
      httpHeaders = new HttpHeaders({
        Authorization: token
      });
      return this.http.post(`${this.URL}/cart/paypal/card?uuid=${uuid}`, {}, { headers: httpHeaders }).toPromise();
    } else {
      return this.http.post(`${this.URL}/cart/paypal/card?uuid=${uuid}`, {}).toPromise();
    }
  }

  public async createOrderPaypalPay(uuid: string, device: string, version: string, token?: string): Promise<any> {
    let httpHeaders: any;
    if (token) {
      httpHeaders = new HttpHeaders({
        Authorization: token
      });
      return this.http.post(`${this.URL}/cart/paypal/card/pay?uuid=${uuid}&device=${device}&version=${version}`, {}, { headers: httpHeaders }).toPromise();
    } else {
      return this.http.post(`${this.URL}/cart/paypal/card/pay?uuid=${uuid}&device=${device}&version=${version}`, {}).toPromise();
    }
  }

  public async generateClientToken(token: string): Promise<any> {
    const httpHeaders = new HttpHeaders({
      Authorization: token
    });
    return this.http.get(`${this.URL}/cart/paypal/client-token`, { headers: httpHeaders }).toPromise();
  }

  public async captureOrderPaypal(uuid: string, orderId: any, token?: string): Promise<any> {
    let httpHeaders: any;
    if (token) {
      httpHeaders = new HttpHeaders({
        Authorization: token
      });
      return this.http.patch(`${this.URL}/cart/paypal/capture/${orderId}?uuid=${uuid}`, {}, { headers: httpHeaders }).toPromise();
    } else {
      return this.http.patch(`${this.URL}/cart/paypal/capture/${orderId}?uuid=${uuid}`, {}).toPromise();
    }
  }

  public async captureOrderPaypalPay(uuid: string, orderId: any, token?: string): Promise<any> {
    let httpHeaders: any;
    if (token) {
      httpHeaders = new HttpHeaders({
        Authorization: token
      });
      return this.http.patch(`${this.URL}/cart/paypal/capture/${orderId}/pay?uuid=${uuid}`, {}, { headers: httpHeaders }).toPromise();
    } else {
      return this.http.patch(`${this.URL}/cart/paypal/capture/${orderId}/pay?uuid=${uuid}`, {}).toPromise();
    }
  }

  public updateCartPaymentMethod(data: any, token?: string): Promise<any> {
    let httpHeaders: any;
    if (token) {
      httpHeaders = new HttpHeaders({
        Authorization: token
      });
      return this.http.patch(`${this.URL}/cart/paypal/card`, data, { headers: httpHeaders }).toPromise();
    } else {
      return this.http.patch(`${this.URL}/cart/paypal/card`, data).toPromise();
    }
  }

  public async deleteRememberedCard(carId: string): Promise<any> {
    return this.http.delete(`${this.URL}/payment-methods/card/${carId}`).toPromise();
  }

  public async deleteRememberedAccount(): Promise<any> {
    return this.http.delete(`${this.URL}/payment-methods/account`).toPromise();
  }

  public async deleteOrder(order_id: string, token?: string): Promise<any> {
    let httpHeaders: any;
    if (token) {
      httpHeaders = new HttpHeaders({
        Authorization: token
      });
      return this.http.delete(`${this.URL}/cart/paypal/${order_id}`, { headers: httpHeaders }).toPromise();
    } else {
      return this.http.delete(`${this.URL}/cart/paypal/${order_id}`).toPromise();
    }
  }

}
